import React, { useState, useEffect } from "react";
import Contact from "../../assets/images/contact.svg";
import Building from "../../assets/images/Uni.svg";
import Edit from "../../assets/images/edit.svg";
import Delete from "../../assets/images/delete.svg";
import CloseIcon from "../../assets/images/clear.svg";
import TextField from "@material-ui/core/TextField";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { mapStateToProps, mapDispatchToProps } from "../../actions/addresses";
import { useStylesContactList } from "./style";
import { useCopyAddress } from "../../hooks/copyAddress";
import ConfirmModal from "../AlertModal/confirmModal";
import * as sdk from "boa-sdk-ts";
import {
  addressFormat,
  loadContactList,
  saveContactList,
} from "../../utils/WalletUtils";
import { WalletMA, WalletResultCode } from "boa-sdk-ts";

const Contacts = (props) => {
  //These are all states of current component
  const { t } = props;
  const classes = useStylesContactList();

  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);

  const [contact, setContact] = useState({ address: "", contactName: "" });
  const [contactList, setContactList] = useState(
    loadContactList() ? loadContactList() : []
  );

  const [updateContactList, setUpdateContactList] = useState(false);
  const [error, setError] = useState("");
  const [errorName, setNameError] = useState("");

  const [editContactInfo, setEditContact] = useState({
    address: "",
    contactName: "",
  });
  const [selectedContact, setSelectedContact] = useState({
    address: "",
    contactName: "",
  });
  const [deletedAddress, setDeletedAddress] = useState("");
  const [copyText, CopyContactAddress] = useCopyAddress();

  // Hook to add contact list
  useEffect(() => {
    const ContactList = loadContactList();
    setContactList(ContactList ? ContactList : []);
  }, [updateContactList, openCreateModal]);

  // Method to open add contact modal
  const handleOpen = () => {
    setOpenCreateModal(true);
  };

  // Method to close add contact modal
  const handleClose = () => {
    setContact({ address: "", contactName: "" });
    setOpenCreateModal(false);
  };

  // Method to open  & close edit contact modal
  const handleEditClose = () => {
    setOpenEditModal(false);
  };

  // Method to set contact info
  const addContactInfo = (e) => {
    setContact({ ...contact, [e.target.name]: e.target.value });
  };

  // Method to set error of address
  const errorAddress = (error) => {
    setError(error);
    setTimeout(() => {
      setError("");
    }, 3000);
  };

  // Method to set error of contact name
  const setErrorName = (error) => {
    setNameError(error);
    setTimeout(() => {
      setNameError("");
    }, 3000);
  };

  // Method to save contact info to localStorage
  const saveContact = async () => {
    const list = loadContactList();
    const selectedAccountAddress =
      WalletMA.instance().accounts.selected_account.address.toString();
    const res = await sdk.WalletValidator.isValidPublicKey(contact.address);
    if (res.code === WalletResultCode.Success) {
      if (list) {
        let filterAddresses = list.filter(
          (info) =>
            info.contactWalletAddress === contact.address ||
            info.contactAddressName === contact.contactName
        );
        if (filterAddresses.length > 0) {
          if (filterAddresses[0].contactWalletAddress === contact.address) {
            errorAddress(t("Contact_address_already_exist"));
          } else {
            setErrorName(t("Contact_with_this_name_already_exists"));
          }
        } else {
          if (contact.address === selectedAccountAddress) {
            errorAddress(t("You_cant_add_your_own_address_to_contact_list"));
          } else {
            list.unshift({
              contactWalletAddress: contact.address,
              userWalletAddress: selectedAccountAddress,
              contactAddressName: contact.contactName
                ? contact.contactName
                : contact.address,
            });
            saveContactList(list);
            setContact({ address: "", contactName: "" });
            setOpenCreateModal(false);
          }
        }
      } else {
        if (contact.address === props.MultiAddresses.Addresses[0]) {
          errorAddress(t("You_cant_add_your_own_address_to_contact_list"));
        } else {
          saveContactList([
            {
              contactWalletAddress: contact.address,
              userWalletAddress: selectedAccountAddress,
              contactAddressName: contact.contactName
                ? contact.contactName
                : contact.address,
            },
          ]);
          setOpenCreateModal(false);
          setContact({ address: "", contactName: "" });
        }
      }
    } else {
      errorAddress(t("This_key_is_not_valid"));
    }
  };

  // Method to Delete contact address and get address as a param
  const deleteContactAddress = (address, status) => {
    setDeletedAddress(address ? address : deletedAddress);
    setOpenConfirmModal(!openConfirmModal);
    if (status) {
      const list = loadContactList();
      let filterAddresses = list.filter(
        (info) => info.contactWalletAddress !== deletedAddress
      );
      saveContactList(filterAddresses);
      setUpdateContactList(!updateContactList);
    } else {
      setUpdateContactList(!updateContactList);
    }
  };

  // Method to edit contact info and get select contact info as a param
  const editContact = (info) => {
    setOpenEditModal(true);
    setSelectedContact({
      address: info.contactWalletAddress,
      contactName: info.contactAddressName,
    });
    setEditContact({
      address: info.contactWalletAddress,
      contactName: info.contactAddressName,
    });
  };

  const EditContactInfo = (e) => {
    setEditContact({ ...editContactInfo, [e.target.name]: e.target.value });
  };

  // Method to save edited change to selected contact
  const saveEditContact = () => {
    const list = loadContactList();
    // Search that already name exist
    let existName = list.filter((info) => {
      if (
        info.contactAddressName === editContactInfo.contactName &&
        info.contactWalletAddress !== editContactInfo.address
      ) {
        return info;
      }
    });
    if (existName.length > 0) {
      setErrorName(t("Contact_with_this_name_already_exists"));
    } else {
      let filterAddresses = list.filter((info) => {
        if (info.contactWalletAddress === editContactInfo.address) {
          return (info.contactAddressName = editContactInfo.contactName
            ? editContactInfo.contactName
            : selectedContact.contactName);
        } else {
          return info;
        }
      });
      saveContactList(filterAddresses);
      setUpdateContactList(!updateContactList);
      setOpenEditModal(false);
    }
  };

  return (
    <>
      <div className="Content">
        <div className="TableBg cardBg">
          <div className="row align-items-center">
            <div className="col-lg-1 col-md-2">
              <img
                alt="Contact"
                className="img-fluid UserContact"
                src={Contact}
              />
            </div>
            <div className="col-lg-8 col-md-10">
              <p className="mb-0">
                {t("This_page_allows_you_to_create_contacts")}
              </p>
            </div>
            <div className="col-lg-3 col-md-12">
              {/* Button to open Add Contact modal */}
              <button
                data-testid="button-sidebar"
                onClick={handleOpen}
                className="btn btn-default contactBtn"
              >
                {t("Add_Contact")}
              </button>
            </div>
          </div>
        </div>
        {/* Contact list section */}
        <div className="TableBg cardBg mt-30">
          <div className="ContHeader pendingTable">
            <h3> {t("Contacts")}</h3>
          </div>
          <div className="table-responsive contact-table">
            <table className="table panelTable">
              <thead className="tableHead">
                <tr>
                  <th> {t("Address")}</th>
                  <th> {t("Contact_Name_Table")}</th>
                  <th> {t("Actions")}</th>
                </tr>
              </thead>
              {contactList.length > 0 ? (
                <tbody className="SenderTable">
                  {contactList.map((info, index) => (
                    <tr key={index}>
                      <td>
                        <div className="align_left">
                          <img
                            alt="Building"
                            className="img-fluid"
                            src={Building}
                          />
                          <div className="purpleText tooltip1 ml-3">
                            {addressFormat(info.contactWalletAddress)}
                            <div className="tooltiptext1">
                              <p>{info.contactWalletAddress}</p>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="contactname purpleText tooltip1">
                          {info.contactAddressName}
                          <div className="tooltiptext1">
                            <p>{info.contactAddressName}</p>
                          </div>
                        </div>
                      </td>
                      <td>
                        <ul className="list-unstyled list-inline contactList">
                          <li
                            className={
                              copyText === info.contactWalletAddress
                                ? "list-inline-item tooltip3 active"
                                : "list-inline-item tooltip3"
                            }
                            onClick={() =>
                              CopyContactAddress(info.contactWalletAddress)
                            }
                          >
                            <i
                              className={
                                copyText === info.contactWalletAddress
                                  ? "fa fa-clone active"
                                  : "fa fa-clone"
                              }
                              aria-hidden="true"
                            />
                            <div className="tooltiptext3">
                              <p>{t("Copied")}</p>
                            </div>
                          </li>
                          <li
                            className="list-inline-item"
                            onClick={() => editContact(info)}
                          >
                            <img alt="Edit" src={Edit} />
                          </li>
                          <li
                            className="list-inline-item"
                            onClick={() =>
                              deleteContactAddress(
                                info.contactWalletAddress,
                                false
                              )
                            }
                          >
                            <img alt="Delete" src={Delete} />
                          </li>
                        </ul>
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : (
                // No data section
                <tbody>
                  <tr className="noData">
                    <td className="inner">
                      <h3 className="text-center mb-3">{t("sorry_no_data")}</h3>
                    </td>
                  </tr>
                </tbody>
              )}
            </table>
          </div>
          <div className="SendModal">
            {/* Add contact modal component */}
            <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              className={classes.modal}
              open={openCreateModal}
              onClose={handleClose}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{
                timeout: 500,
              }}
            >
              <Fade in={openCreateModal}>
                <div className={`${classes.paper} ${"modalBg"}`}>
                  <img
                    alt="CloseIcon"
                    className="ClearModalImg"
                    src={CloseIcon}
                    onClick={() => {
                      handleClose();
                    }}
                  />
                  <h2 className="modalTitle" id="transition-modal-title">
                    {t("Add_Contact")}
                  </h2>
                  <div className="modalInput mb-40">
                    <TextField
                      label={t("Address")}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={contact.address}
                      name="address"
                      onChange={(e) => addContactInfo(e)}
                      placeholder={t("Enter_Address")}
                    />
                    <div className="validText">
                      <p
                        className="validText"
                        style={{ color: "red", width: "100%" }}
                      >
                        {error}
                      </p>
                    </div>
                  </div>
                  <div className="modalInput">
                    <TextField
                      label={t("Contact_Name")}
                      value={contact.contactName}
                      name="contactName"
                      onChange={(e) => addContactInfo(e)}
                    />
                  </div>
                  <div className="validText">
                    <p
                      className="validText"
                      style={{ color: "red", width: "100%" }}
                    >
                      {errorName}
                    </p>
                  </div>
                  <p className="mt-3 greyText">
                    <span className="infoText">{t("Info")}:</span>{" "}
                    {t("Contact_Name_Required")}
                  </p>
                  <div className="modal_footer">
                    <button
                      className="btn btn-default senderBtn"
                      disabled={!contact.address}
                      onClick={saveContact}
                    >
                      {t("Add")}
                    </button>
                    <button
                      className="btn btn-default cancel_btn"
                      onClick={handleClose}
                    >
                      {t("Cancel")}
                    </button>
                  </div>
                </div>
              </Fade>
            </Modal>
          </div>
          <div className="SendModal">
            {/* Edit contact name modal component */}
            <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              className={classes.modal}
              open={openEditModal}
              onClose={handleEditClose}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{
                timeout: 500,
              }}
            >
              <Fade in={openEditModal}>
                <div className={`${classes.paper} ${"modalBg"}`}>
                  <img
                    alt="CloseIcon"
                    className="ClearModalImg"
                    src={CloseIcon}
                    onClick={handleEditClose}
                  />
                  <h2 className="modalTitle" id="transition-modal-title">
                    {t("Edit_Contact_Name")}
                  </h2>
                  <div className="modalInput flex-wrap">
                    <TextField
                      label={t("Contact_Name")}
                      value={editContactInfo.contactName}
                      name="contactName"
                      onChange={(e) => EditContactInfo(e)}
                    />
                  </div>
                  <div className="validText">
                    <p style={{ color: "red", width: "100%" }}>{errorName}</p>
                  </div>
                  <div className="modal_footer">
                    <button
                      className="btn btn-default senderBtn"
                      disabled={false}
                      onClick={(e) => saveEditContact(e)}
                    >
                      {t("Save")}
                    </button>
                    <button
                      className="btn btn-default cancel_btn"
                      onClick={handleEditClose}
                    >
                      {t("Cancel")}
                    </button>
                  </div>
                </div>
              </Fade>
            </Modal>
          </div>
        </div>
      </div>
      {/* Delete record confirmation modal component */}
      <ConfirmModal
        open={openConfirmModal}
        actionEventConfirm={deleteContactAddress}
        message={t("Are_you_sure_you_want_to_delete_this_address")}
      />
    </>
  );
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Contacts))
);
